import { IconContent } from '@icons';

export const arrowClockwise: IconContent = {
    sm: '<path d="M10.854 4.354 11.207 4l-.353-.354L8.104.897l-.707.707L9.293 3.5H8A5.5 5.5 0 1 0 13.5 9h-1A4.5 4.5 0 1 1 8 4.5h1.293L7.397 6.396l.707.707 2.75-2.75Z" />',
};
